import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://thiranx.in';
const DEFAULT_IMAGE = `${SITE_URL}/favicon-512.png`;

/**
 * Per-page SEO tags. Renders a unique title/description/canonical/OG/Twitter
 * set for the page it's mounted on, overriding the static defaults in index.html.
 * Pass `schema` (a JSON-LD object or array of objects) to emit structured data.
 */
const Seo = ({ title, description, path = '/', image = DEFAULT_IMAGE, noindex = false, schema, rawTitle = false }) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = !title ? 'ThiranX | Learn. Grow. Certify.' : rawTitle ? title : `${title} | ThiranX`;
  const schemaList = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={image} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      {description && <meta property="twitter:description" content={description} />}
      <meta property="twitter:image" content={image} />

      {schemaList.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
export { SITE_URL };
